module.exports = __webpack_public_path__ + "img/search.20935089.png";